.content {
	width: 100%;
	height: 91.5vh;
	background-color: #eff0f2;
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: sans-serif;
}

.main {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.error {
	font-size: 3em;
	background-color: #85bf49;
	color: #fff;
	text-transform: uppercase;
	padding: 15px 25px;
	font-weight: bolder;
	border-radius: 15px 25px;
	width: fit-content;
}

.message {
	color: #477990;
	font-size: 2em;
	text-transform: uppercase;
	padding: 10px;
}

.buttonback {
	background-color: #85bf49;
	padding-left: 2em;
	padding-right: 2em;
	padding-top: 0.5em;
	padding-bottom: 0.5em;
	color: white;
	border-radius: 5px;
	margin-top: 6em;
	cursor: pointer;
}
